export default "<app-home></app-home>\n<app-loader *ngIf=\"isLoading\"></app-loader>"